import { Controller } from '@hotwired/stimulus'
import { toggleVisibility } from 'utils/toggle_element_visibility'

export default class extends Controller {
  static targets = ["loginForm", "signupForm", "continueToInput", "pageTitleInput", "connectButton"]

  switchToLogin(event) {
    event.preventDefault()

    // Update the body
    toggleVisibility(this.loginFormTarget, true)
    toggleVisibility(this.signupFormTarget, false)

    // Update the header
    this._updateTitle(this.loginFormTarget.dataset["modalTitle"])

    // Update the focus
    this.element.querySelector('[data-js-login-email]').focus()
  }

  switchToSignUp(event) {
    event.preventDefault()

    // Update the body
    toggleVisibility(this.loginFormTarget, false)
    toggleVisibility(this.signupFormTarget, true)

    // Update the header
    this._updateTitle(this.signupFormTarget.dataset["modalTitle"])
  }

  onModalLoad(event) {
    this._updateContinueTo(event)
    this._updatePageTitle()
    this._focusFirstInput()
  }

  _updatePageTitle() {
    if (this.pageTitleInputTargets.length > 0) {
      this.pageTitleInputTarget.value = document.title
    }
  }

  _updateContinueTo(event) {
    // Extract continue_to param from the triggerElement, or the event (via Modal.open)
    let continueTo
    const triggerElement = event.detail.requestConfig.elt
    if (triggerElement) {
      continueTo = triggerElement.dataset["continueTo"]
    } else if (event.detail.extras) {
      continueTo = event.detail.extras.continueTo
    }

    if (continueTo) {
      // Set the hidden input in the modal form
      this.continueToInputTargets.forEach((input) => { input.value = continueTo })

      // Update the provider link URL with continue_to param
      this.connectButtonTargets.forEach((element) => {
        const originalHref = element.getAttribute("href")
        if (originalHref) {
          // Use window.location.origin as base for relative URLs
          const url = new URL(originalHref, window.location.origin)
          if (!url.searchParams.has('continue_to')) {
            url.searchParams.set('continue_to', continueTo)
            // If the original URL was relative, keep it relative
            element.href = originalHref.startsWith('http') ? url.toString() : url.pathname + url.search
          }
        }
      })
    }
  }

  _focusFirstInput() {
    const firstInput = this.element.querySelector('input:not([type=hidden])')
    if (firstInput) {
      firstInput.focus()
    }
  }

  _updateTitle(newTitle) {
    const modalTitleElement = this.element.querySelector("[data-js-modal-header-text]")
    modalTitleElement.innerHTML = newTitle
  }
}
